import { AxiosRequestConfig } from "axios"
import { HttpClient } from "~/api/HttpClient"
import { AttributesCategory } from "~/types/types"

export const API_PREFIX_PATH = "/api/cateogries"
export const fetchCategories = async (searchTerm?: string, populate?: string) => {
  const params: AxiosRequestConfig["params"] = {
    populate: populate ? "" : "*",

    sort: "createdAt:desc",
    filters: {
      name: { $containsi: searchTerm },
    },
  }
  return await HttpClient.get(`${API_PREFIX_PATH}`, {
    params,
  })
}

export const updateCategory = async (id: string, updatedData: AttributesCategory) => {
  return await HttpClient.put(`${API_PREFIX_PATH}/${id}`, { data: updatedData })
}
export const createCategory = async (data: AttributesCategory) => {
  return await HttpClient.post(`${API_PREFIX_PATH}`, { data })
}

export const deleteCategory = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_PATH}/${id}`)
}

export const getCategoryById = async (id: number) => {
  return await HttpClient.get(`${API_PREFIX_PATH}/${id}`)
}

export const fetchTags = async () => {
  return await HttpClient.get(`/api/tags`)
}
export const checkSlug = async (slug: string) => {
  const params: AxiosRequestConfig["params"] = {
    filters: {
      slug: { $eq: slug },
    },
    publicationState: "preview",
  }
  return await HttpClient.get(`${API_PREFIX_PATH}`, { params })
}
